import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=3ae6a39b&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"
import style0 from "./Phone.vue?vue&type=style&index=0&id=3ae6a39b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6a39b",
  null
  
)

export default component.exports